import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = [
    {
        "headerHash": "9df09bb3b85e9938c402df01141bba22b0065654bf79e36672363c2667fb2a03",
        "luck": 136,
        "blockNumber": 630508,
        "reward": 1.75,
        "dateTimeUtc": "2021-07-27T09:56:21.0000000Z",
        "winnerLauncherId": "1c8b450d00954a62cb458394723cd23deecf93e6df126f20c5fdce1cf0253f43",
        "confirmed": true
    },
    {
        "headerHash": "d59eb05458c4f2e6bd8b800b3be4f9b87fae4eeb90954108d01e7b61321a4217",
        "luck": 1,
        "blockNumber": 630466,
        "reward": 1.75,
        "dateTimeUtc": "2021-07-27T09:42:44.0000000Z",
        "winnerLauncherId": "d3d26bee27da7f965d3ec1d1238d29b1e0018dcc6939f51d1d3899d12bb7e4db",
        "confirmed": true
    },
    {
        "headerHash": "5ec57942b767f20a25ca36cdda214369c8b492d905e2297d855c870caf1a8869",
        "luck": 87,
        "blockNumber": 630400,
        "reward": 1.75,
        "dateTimeUtc": "2021-07-27T09:22:01.0000000Z",
        "winnerLauncherId": "ac16b5def735ea1992d1c2886df6bc22b96685291cbe82328ce11d99bbfcd151",
        "confirmed": true
    },
    {
        "headerHash": "a90a9347c04f8f264b42ca295b40effd22dee7d23f5275a662a9533da0db53e7",
        "luck": 54,
        "blockNumber": 630353,
        "reward": 1.75,
        "dateTimeUtc": "2021-07-27T09:08:11.0000000Z",
        "winnerLauncherId": "ea2bf30a0e3b56ae14743ed131aa58c613d2f05a0205028005124f1cba47b115",
        "confirmed": true
    },
    {
        "headerHash": "5866dd051f2ec05e2db1cebcd7d70bea1e832a27613ed997dd95638533bfc132",
        "luck": 148,
        "blockNumber": 630319,
        "reward": 1.75,
        "dateTimeUtc": "2021-07-27T08:58:31.0000000Z",
        "winnerLauncherId": "2aeaed0884d19b5f09ae57d135574c043437ed88e7ae702d55f02d5598ac85d5",
        "confirmed": true
    }
]
/* eslint-disable global-require */
mock.onGet('/poolList/data').reply(() => [200, data])
